import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import TopAction from '../CompanyData/TopActions';
import CompanyDataForm from './Form';
import { loadStyle } from 'globalutils/fmUtils';
import ParentStyled from './style';

const Styled = loadStyle(ParentStyled, 'pages/web/CompanyManagement');

const Component = ({ theme, topAction, i18n, updateCard, callback, history, ...rest }) => {
  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Styled.Wrapper>
        <TopAction {...{ i18n, updateCard, callback, history, Styled }} />
        <CompanyDataForm {...rest} Styled={Styled} i18n={i18n} updateCard={updateCard} callback={callback} history={history} />
      </Styled.Wrapper>
    </Box>
  );
};

Component.propTypes = {
  Styled: PropTypes.object.isRequired,
};

export default Component;
